import { FC, useEffect, useState } from 'react';
import { IBasicProductsCare, IProductsCare } from '../../../../../../types/bussines';
import { BlackCheckIcon } from '../../../../../../assets/images/countryList';
import { ExternalIcon, InternalIcon } from '../../../../../../assets/images';
import { formatShortDate } from '../../../../../../utils/formatDatesAndHours';
import { REFERENCE_MODEL_TYPE } from '../../../../../../types/global';
import './NudosCareCard.scss';

interface INudosCareCard {
  dataCareCard: IProductsCare;
  isEditable: boolean;
  handleEditProductsCare: (e: IBasicProductsCare) => void;
}

const NudosCareCard: FC<INudosCareCard> = ({ dataCareCard, isEditable, handleEditProductsCare }: INudosCareCard) => {
  const [nudosCareLevel, setNudosCareLevel] = useState<'Free' | 'Basic' | 'Log' | 'Full'>();

  useEffect(() => {
    if (dataCareCard && dataCareCard.nudosCare) {
      setNudosCareLevel(dataCareCard.nudosCare);
    }
  }, [dataCareCard]);
  return (
    <div id="nudosCareCard">
      <div className="pointName">
        <div className="blackPoint" />
      </div>
      <div className="toolName">
        {`${dataCareCard?.serial ? `${dataCareCard?.serial} /` : ''} ${dataCareCard.nudosId} - ${
          dataCareCard.productName
        }`}
        <div className="containerTypeTool">
          {dataCareCard.referenceCatalog === REFERENCE_MODEL_TYPE.INTERNAL && <InternalIcon />}
          {dataCareCard.referenceCatalog === REFERENCE_MODEL_TYPE.EXTERNAL && <ExternalIcon />}
          {dataCareCard.referenceCatalog === REFERENCE_MODEL_TYPE.STOCK && <InternalIcon />}
        </div>
      </div>
      <div className="containerChecks">
        <div className="containerCheck mr-8">
          {nudosCareLevel === 'Free' ? (
            <div className="containerLevel">
              {dataCareCard?.isKit ? <div className="blockCheck" /> : <BlackCheckIcon />}
            </div>
          ) : (
            <>
              {isEditable && !dataCareCard?.isKit ? (
                <div
                  className="checkEnabled"
                  onClick={() => {
                    handleEditProductsCare({ nudosCare: 1, productId: dataCareCard.productId });
                    setNudosCareLevel('Free');
                  }}
                />
              ) : (
                <>{dataCareCard?.isKit ? <div className="blockCheck" /> : <div className="noCheck" />}</>
              )}
            </>
          )}
          <div
            className={`fontCheck ${
              (nudosCareLevel === 'Free' || isEditable) && !dataCareCard.isKit ? 'selectLevel' : ''
            }`}
          >
            Free
          </div>
        </div>
        <div className="containerCheck mr-8">
          {nudosCareLevel === 'Basic' ? (
            <div className="containerLevel">
              {dataCareCard?.isKit ? <div className="blockCheck" /> : <BlackCheckIcon />}
            </div>
          ) : (
            <>
              {isEditable && !dataCareCard?.isKit ? (
                <div
                  className="checkEnabled"
                  onClick={() => {
                    handleEditProductsCare({ nudosCare: 2, productId: dataCareCard.productId });
                    setNudosCareLevel('Basic');
                  }}
                />
              ) : (
                <>{dataCareCard?.isKit ? <div className="blockCheck" /> : <div className="noCheck" />}</>
              )}
            </>
          )}
          <div
            className={`fontCheck ${
              (nudosCareLevel === 'Basic' || isEditable) && !dataCareCard?.isKit ? 'selectLevel' : ''
            }`}
          >
            Basic
          </div>
        </div>
        <div className="containerCheck mr-8">
          {nudosCareLevel === 'Log' ? (
            <div className="containerLevel">
              {dataCareCard?.isKit ? <div className="blockCheck" /> : <BlackCheckIcon />}
            </div>
          ) : (
            <>
              {isEditable && !dataCareCard?.isKit ? (
                <div
                  className="checkEnabled"
                  onClick={() => {
                    handleEditProductsCare({ nudosCare: 3, productId: dataCareCard.productId });
                    setNudosCareLevel('Log');
                  }}
                />
              ) : (
                <>{dataCareCard?.isKit ? <div className="blockCheck" /> : <div className="noCheck" />}</>
              )}
            </>
          )}
          <div
            className={`fontCheck ${
              (nudosCareLevel === 'Log' || isEditable) && !dataCareCard?.isKit ? 'selectLevel' : ''
            }`}
          >
            {' '}
            Log.
          </div>
        </div>
        <div className="containerCheck">
          {nudosCareLevel === 'Full' ? (
            <div className="containerLevel">
              {dataCareCard?.isKit ? <div className="blockCheck" /> : <BlackCheckIcon />}
            </div>
          ) : (
            <>
              {isEditable && !dataCareCard?.isKit ? (
                <div
                  className="checkEnabled"
                  onClick={() => {
                    handleEditProductsCare({ nudosCare: 4, productId: dataCareCard.productId });
                    setNudosCareLevel('Full');
                  }}
                />
              ) : (
                <>{dataCareCard?.isKit ? <div className="blockCheck" /> : <div className="noCheck" />}</>
              )}
            </>
          )}
          <div
            className={`fontCheck ${
              (nudosCareLevel === 'Full' || isEditable) && !dataCareCard?.isKit ? 'selectLevel' : ''
            }`}
          >
            {' '}
            Full
          </div>
        </div>
      </div>
      <div className="dateCareContainer">
        <div className="startCareDate">
          {dataCareCard?.startDate ? (
            <div className="startDate"> {`Inicio: ${formatShortDate(dataCareCard?.startDate)?.textWithTimezone}`}</div>
          ) : (
            <div className="noStartDate">Inicio: -</div>
          )}
        </div>
        <div className="endCareDate">
          {dataCareCard?.endDate ? (
            <div className="endDate">{`Fin: ${formatShortDate(dataCareCard?.endDate)?.textWithTimezone}`}</div>
          ) : (
            <div className="noEndDate">Fin: -</div>
          )}
        </div>
      </div>
      <div className="grayLine" />
    </div>
  );
};

export default NudosCareCard;
